import React from 'react';
import { Form, Input, Select, Typography } from 'antd';

const { TextArea } = Input;
const { Text } = Typography;
const { Option } = Select;

const ReduceNodeProperties = ({ config }) => {
  return (
    <>
      <Form.Item label="Reduce Function" name="reduceFunction" initialValue={config.reduceFunction || ''} rules={[{ required: true }]}>
        <TextArea 
          rows={4} 
          placeholder="e.g., (accumulator, current) => accumulator + current.amount"
        />
      </Form.Item>
      
      <Form.Item label="Initial Value" name="initialValue" initialValue={config.initialValue || '0'} rules={[{ required: true }]}>
        <Input placeholder="Starting value for accumulator (e.g., 0, {}, [])" />
      </Form.Item>

      <Form.Item label="Result Field Name" name="resultField" initialValue={config.resultField || 'result'} rules={[{ required: true }]}>
        <Input placeholder="Name for the aggregated result field" />
      </Form.Item>

      <Form.Item label="Description" name="description" initialValue={config.description || ''}>
        <Input placeholder="Describe the aggregation being performed" />
      </Form.Item>

      <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px', marginTop: '12px' }}>
        <Text type="secondary">
          <strong>Reduce Node:</strong><br/>
          • Aggregates entire dataset into single value<br/>
          • Use JavaScript reduce function syntax<br/>
          • accumulator: running total/result<br/>
          • current: current row being processed<br/>
          • Returns single aggregated result
        </Text>
      </div>
    </>
  );
};

export default ReduceNodeProperties;